module.exports = __webpack_public_path__ + "static/media/Nenhuma.98f663ff.svg";